import React, { useState, useEffect } from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"
const exp = [
  {
    company: "YNAP",
    designation: "CRM Specialist",
    handle_name: "ynap",
    from: "Sepetember 2021",
    to: "Present",
    jd: [
      "Developing and implementing the company's CRM strategy to improve customer engagement and retention.",
      "Identifying and segmenting the company's customer base to create targeted marketing campaigns and personalized communications.",
      "Analyzing customer data and behavior to identify trends and insights that can be used to improve the company's CRM strategy.",
      "Collaborating with other departments, including marketing, sales, and customer service, to ensure that the company's CRM strategy is aligned with the company's overall goals and objectives.",
      "Managing the company's customer database and ensuring that it is accurate and up-to-date.",
      "Creating and implementing loyalty programs, referral programs, and other initiatives to improve customer loyalty and retention.",
      "Developing and managing email marketing campaigns, including designing email templates, creating email lists, and measuring email performance.",
      "Analyzing the effectiveness of the company's CRM strategy and making recommendations for improvement.",
      "Keeping up-to-date with the latest trends and technologies in CRM and using this knowledge to improve the company's CRM strategy.",
      "Developing and implementing training programs to ensure that all employees are knowledgeable about the company's CRM strategy and understand their role in delivering a great customer experience.",
      "Ensuring that the company is compliant with data protection and privacy laws and regulations"
    ],
  },
  {
    company: "Maxzon Tech",
    designation: "Mentor",
    handle_name: "maxzon_tech",
    from: "August 2021",
    to: "Present",
    jd: [
    "Mentoring and guiding software developers working on the online education app.",
    "Providing technical assistance and support to developers, answering their questions and helping them overcome technical challenges.",
    "Reviewing code written by developers to ensure that it adheres to coding standards and best practices.",
    "Identifying skill gaps and areas for improvement among developers and recommending appropriate training or learning opportunities.",
    "Collaborating with other mentors and stakeholders to ensure that the online education app meets the company's technical and business requirements.",
    "Providing input on technology stack selection, architecture design, and other technical decisions related to the online education app.",
    "Communicating effectively with non-technical stakeholders, including product managers and designers, to ensure that their needs and requirements are met.",
    "Staying up-to-date with emerging technologies and trends related to online education and providing guidance on their use in the app development.",
    "Continuously evaluating and improving the mentoring program to ensure that it meets the needs of the developers and the company.",
    "Acting as a role model for the development team, demonstrating a positive attitude and a commitment to quality, excellence, and continuous learning."
    ],
  },
  {
    company: "Dominion Inc",
    designation: "Senior Software Engineer",
    handle_name: "dominion_inc",
    from: "November 2020",
    to: "Present",
    jd: [
      "Designing and developing software solutions using programming languages, tools, and frameworks.",
      "Writing high-quality code and adhering to coding standards and best practices.",
      "Mentoring and leading other engineers, including junior engineers and other team members.",
      "Collaborating effectively with cross-functional teams, including product managers, designers, quality assurance engineers, and other stakeholders.",
      "Providing technical guidance and direction on technology stack selection, architecture design, and best practices to follow.",
      "Staying up-to-date with new and emerging technologies and applying them effectively to improve the software development process.",
      "Participating in testing and debugging to ensure that the software is of high quality and is stable.",
      "Actively involved in the software development process improvement by suggesting improvements and driving initiatives to optimize and automate software development processes."
    ],
  },
  {
    company: "Landmark Group",
    designation: "Data Engineer/ CRM Specialist",
    handle_name: "landmark_group",
    from: "April 2018",
    to: "November 2020",
    jd: [
      "Developing and maintaining the company's data infrastructure, including data warehousing, ETL processes, and other data engineering tasks.",
      "Ensuring that data is collected, stored, and processed in a secure and efficient manner, and that data quality is maintained.",
      "Developing and maintaining data pipelines and integrations between various systems and data sources.",
      "Collaborating with data analysts and business stakeholders to understand their data needs and requirements, and to design data solutions that meet those needs.",
      "Designing and implementing data models and schema, and ensuring that data is organized in a way that enables efficient querying and analysis.",
      "Creating and maintaining documentation for data infrastructure and processes, and providing training and support to other team members as needed.",
      "Identifying and segmenting the company's customer base to create targeted marketing campaigns and personalized communications.",
      "Collaborating with other departments, including marketing, sales, and customer service, to ensure that the company's CRM strategy is aligned with the company's overall goals and objectives.",
      "Managing the company's customer database and ensuring that it is accurate and up-to-date."
    ],
  },
  {
    company: "ME Digital Group",
    designation: "CRM Specialist",
    handle_name: "medigitalgroup",
    from: "July 2017",
    to: "April 2018",
    jd: [
      "Developing and implementing CRM strategies that improve customer engagement and retention",
      "Managing customer databases and ensuring data accuracy",
      "Creating customer segments and executing targeted marketing campaigns",
      "Analyzing customer data to identify trends, insights, and opportunities",
      "Collaborating with cross-functional teams, such as sales and marketing, to ensure the CRM system is meeting business needs",
      "Monitoring and optimizing the performance of the CRM system",
      "Ensuring compliance with data privacy regulations, such as GDPR and CCPA"
    ],
  },
  {
    company: "BLITS",
    designation: "Full stack Developer",
    handle_name: "blits",
    from: "February 2015",
    to: "March 2017",
    jd: [
      "Writing clean, semantic, and well-documented HTML, CSS, and JavaScript code",
      "Developing and implementing user interface designs and web layouts",
      "Creating responsive designs that work on different devices and screen sizes",
      "Using modern front-end frameworks such as React, Angular, or Vue.js to develop web applications",
      "Debugging and troubleshooting code issues to ensure a smooth user experience",
      "Collaborating with UX designers and other developers to ensure the design and functionality of web applications meet user needs",
      "Optimizing web applications for speed and scalability",
      "Ensuring cross-browser compatibility and accessibility of web applications",
      "Integrating third-party APIs and services into web applications",
      "Conducting code reviews and providing feedback to other developers to maintain code quality and best practices"
    ],
  },
  {
    company: "Govt Start Up",
    designation: "Software Developer",
    handle_name: "govtstartupmission",
    from: "July 2014",
    to: "December 2014",
    jd: [
      "Developing, testing, and maintaining software applications and systems.",
      "Collaborating with other members of the development team to design and implement new features and functionality.",
      "Identifying and resolving technical issues, bugs, and other software defects.",
      "Writing clean, efficient, and well-documented code that meets industry standards.",
      "Participating in code reviews and providing feedback to other team members.",
      "Staying up-to-date with the latest technologies, tools, and best practices in software development.",
      "Contributing to the overall product roadmap and strategy.",
      "Working closely with product managers, designers, and other stakeholders to ensure that software development is aligned with business goals.",
      "Participating in agile development processes, including sprint planning, daily stand-ups, and retrospectives.",
      "Mentoring junior developers and helping to create a culture of continuous learning and improvement."
    ],
  },
]
export default function Experience() {
  const [selectedCompany, setSelectedCompany] = useState()
  useEffect(() => {
    setSelectedCompany(exp[0].company)
  }, [])
  return (
    <Layout>
      <Seo title="About me" />
      <section className="section">
        <h2 className="sectionHead rotate">experience_</h2>
        <div className="sectionContent">
          <div className="experienceSection">
            <div>
              {exp.map(item => (
                <div
                  className={
                    selectedCompany == item.company
                      ? "selectedCompanyClass"
                      : "experienceCompanyname"
                  }
                >
                  <h3 onClick={() => setSelectedCompany(item.company)}>
                    {item.company}
                  </h3>
                </div>
              ))}
            </div>
            <div className="experience_details">
              {exp.map(item => (
                <>
                  {item.company == selectedCompany && (
                    <>
                      <h3>
                        {item.designation} @{item.handle_name}
                      </h3>
                      <p>
                        {item.from} - {item.to}
                      </p>
                      <ul>
                        {item.jd.map(jd => (
                          <li>{jd}</li>
                        ))}
                      </ul>
                    </>
                  )}
                </>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}
